import React from 'react';
import CardHeader from '@material-ui/core/CardHeader';
import Select from 'components/form/Select';
import PRODUCT_TYPES from 'constant/product-types';

const SectionHeader = ({ title, productType, setProductType }) => {
  return (
    <CardHeader
      title={title}
      subheader="Select a product to override template for specific product. Saving empty message will not send the notification. Default message will be sent if no product specific message is saved."
      titleTypographyProps={{ variant: 'subtitle1' }}
      action={
        setProductType && (
          <Select
            noMargin
            transformValue
            isClearable
            value={productType}
            onChange={setProductType}
            isMulti={false}
            options={PRODUCT_TYPES}
            style={{ width: 200 }}
          />
        )
      }
    />
  );
};

export default SectionHeader;
